import React, { useState } from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import SlidingPaneUtil from "../../../../utils/SlidingPaneUtil";
import AddEmployeeForm from "../../../../components/Forms/StructureForm/AddEmployeeForm/AddEmployeeForm";
import StructureTreeView from "../StructureTree/StructureTreeView";

const StructureTree = ({ data, setRender, setTitle }) => {
  const { t } = useTranslation('common');
  const [state, setState] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });

  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);
  useEffect(() => {
    width < 600 && handleSideNavToggle();
  });

  function handleSideNavToggle() {
  }

  function transformData(data) {
    const transformedData = {
      id: data?.id,
      name: data?.title,
      structure_name: "organization",
      creator: data?.employee,
      user_id: data?.user_id,
      attributes: {
        status: `${t('structure.waiting_since')} ${data?.created}`,
        instructor: data?.employee,
      },
      children: [],
    };

    if (data?.managements.length === 0) {
      data?.branches?.forEach((branch) => {
        const branchNode = {
          id: branch.id,
          name: branch.title,
          creator: data?.employee,
          structure_name: "branch",
          attributes: {},
          children: [],
        };

        branch.subbranches?.forEach((subbranch) => {
          const subbranchNode = {
            id: subbranch.id,
            name: subbranch.title,
            creator: data?.employee,
            structure_name: "subbranch",
            attributes: {},
            children: [],
          };

          branchNode.children.push(subbranchNode);
        });

        transformedData.children.push(branchNode);
      });
    } else {
      data?.managements?.forEach((management) => {
        const managementNode = {
          id: management.id,
          name: management.title,
          structure_name: "management",
          creator: data?.employee,
          attributes: {},
          children: [],
        };

        management.branches?.forEach((branch) => {
          const branchNode = {
            id: branch.id,
            name: branch.title,
            structure_name: "branch",
            creator: data?.employee,
            attributes: {},
            children: [],
          };

          branch.subbranches?.forEach((subbranch) => {
            const subbranchNode = {
              id: subbranch.id,
              name: subbranch.title,
              structure_name: "subbranch",
              creator: data?.employee,
              attributes: {},
              children: [],
            };

            branchNode.children.push(subbranchNode);
          });

          managementNode.children.push(branchNode);
        });

        transformedData.children.push(managementNode);
      });
    }

    return transformedData;
  }

  const transformedData = transformData(data);

  setTitle(transformedData.name);
  return (
    <div>
      

      <StructureTreeView
        data={transformedData}
        setState={setState}
        setRender={setRender}
      />
      {width > 1000 ? (
        <>
          <SlidingPaneUtil
            size="900px"
            title={t('structure.hr_department')}
            state={state}
            setState={setState}
            onRequestClose={() => {
              setState({ isPaneOpen: false });
            }}
          >
            {" "}
            <AddEmployeeForm
              data={data}
              setRender={setRender}
              setState={setState}
            />
          </SlidingPaneUtil>
        </>
      ) : (
        <>
          <SlidingPaneUtil
            size="100%"
            title={t('structure.hr_department')}
            state={state}
            setState={setState}
            onRequestClose={() => {
              setState({ isPaneOpen: false });
            }}
          >
            {" "}
            <AddEmployeeForm
              data={data}
              setRender={setRender}
              setState={setState}
            />
          </SlidingPaneUtil>
        </>
      )}
    </div>
  );
};

export default StructureTree;
